import type { AssetDetail, AssetHistoryEntry, PortView, TraceResult } from '@ftthnms/shared';
import { useQuery, type QueryClient } from '@tanstack/react-query';
import { api } from './api';

export const useAsset = (id: string | null | undefined) =>
  useQuery({
    queryKey: ['asset', id],
    queryFn: () => api<AssetDetail>(`/api/v1/assets/${id}`),
    enabled: !!id,
  });

export const usePorts = (id: string | null | undefined, enabled = true) =>
  useQuery({
    queryKey: ['asset', id, 'ports'],
    queryFn: () => api<PortView[]>(`/api/v1/assets/${id}/ports`),
    enabled: !!id && enabled,
  });

export const useTrace = (id: string | null | undefined, enabled = true) =>
  useQuery({
    queryKey: ['asset', id, 'trace'],
    queryFn: () => api<TraceResult>(`/api/v1/assets/${id}/trace`),
    enabled: !!id && enabled,
  });

export const useHistory = (id: string | null | undefined, enabled = true) =>
  useQuery({
    queryKey: ['asset', id, 'history'],
    queryFn: () => api<AssetHistoryEntry[]>(`/api/v1/assets/${id}/history`),
    enabled: !!id && enabled,
  });

/** After any asset, port or route change: lists, map layers, dashboard and open detail views refetch. */
export function invalidateAssets(qc: QueryClient) {
  return Promise.all(
    [
      'asset',
      'assets',
      'map-features',
      'areas',
      'route',
      'routes',
      'map-routes',
      'customers',
      'cost',
      'dashboard',
    ].map((key) => qc.invalidateQueries({ queryKey: [key] })),
  );
}
